var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3051 5.06731C11.7315 3.3109 14.2294 3.3109 14.6558 5.06731C14.9313 6.20193 16.2312 6.74038 17.2283 6.13285C18.7718 5.19239 20.5381 6.9587 19.5976 8.50218C18.9901 9.49925 19.5285 10.7992 20.6632 11.0746C22.4196 11.501 22.4196 13.999 20.6632 14.4254C19.5285 14.7008 18.9901 16.0007 19.5976 16.9978C20.5381 18.5413 18.7718 20.3076 17.2283 19.3672C16.2312 18.7596 14.9313 19.2981 14.6558 20.4327C14.2294 22.1891 11.7315 22.1891 11.3051 20.4327C11.0296 19.2981 9.72973 18.7596 8.73266 19.3672C7.18917 20.3076 5.42286 18.5413 6.36332 16.9978C6.97084 16.0007 6.4324 14.7008 5.29778 14.4254C3.54137 13.999 3.54137 11.501 5.29778 11.0746C6.4324 10.7992 6.97084 9.49926 6.36332 8.50218C5.42286 6.9587 7.18917 5.19239 8.73265 6.13285C9.72972 6.74037 11.0296 6.20193 11.3051 5.06731Z",
    stroke: "#059669",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9805 12.75C15.9805 14.4069 14.6373 15.75 12.9805 15.75C11.3236 15.75 9.98047 14.4069 9.98047 12.75C9.98047 11.0931 11.3236 9.75 12.9805 9.75C14.6373 9.75 15.9805 11.0931 15.9805 12.75Z",
    stroke: "#059669",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveSetting);
export default __webpack_public_path__ + "static/media/ActiveSetting.09c1b1ea17afce5c43333c9168ad489a.svg";
export { ForwardRef as ReactComponent };